<template>
  <div>
    <!-- isReady: {{isReady}} || {{goalId}} -->
    <router-link :to="'/goal/'+goalId">&larr; Go back to goal details</router-link>
    <template v-if="isReady">
      <Kanban :goal-id="goalId" :key="goalId" />
    </template>
    <template v-else>
      Loading...
    </template>
  </div>
</template>

<script>
import Kanban from '@/components/GoalPage/Kanban'

export default {
  name: "KanbanPage",
  data() {
    return {
      goalId: null
    }
  },
  created() {
    this.setCurrentGoal();
  },
  watch: {
    $route (to, from) {
      if ( to.name === 'kanban' ) {
        this.setCurrentGoal();
      }
    }
  },
  computed: {
    // ...mapGetters("goal", [
    //   "goal_is_ready"
    // ]),

    isReady() {
      return this.$api.get_ready( 'goal', this.goalId )
      // TODO: This should go on any top level page that shows a goal
      // return this.goal_is_ready( this.goalId );
    },
  },
  methods: {
    setCurrentGoal() {
      this.goalId = this.$route.params.goalId;
    },
  },
  components: {
    Kanban,
  }
};
</script>
